import { render, staticRenderFns } from "./receivable-list.vue?vue&type=template&id=80b32b3e&scoped=true"
import script from "./receivable-list.vue?vue&type=script&lang=js"
export * from "./receivable-list.vue?vue&type=script&lang=js"
import style0 from "./receivable-list.vue?vue&type=style&index=0&id=80b32b3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b32b3e",
  null
  
)

export default component.exports